import React, { useState, useEffect, lazy } from "react";
const List = lazy(() => import("../List"));
const SkeletonList = lazy(() => import("../Skeleton/List"));
const SkeletonTitle = lazy(() => import("../Skeleton/Title"));
const TmsErrorHandler = lazy(() => import("../TmsErrorHandler"));
import RequestService from "../../utils/fetch";
// TODO: check to remove "/index"
import translations from "../../translations/index";
const TmsRelatedJobs = (props) => {
    let { ...config } = props;
    const configName = "myTalentionConfig";
    config = props.config || window[configName] || {};
    const [hasErrored, setHasErrored] = useState(!Object.keys(config).length);
    const [errorMessage, setErrorMessage] = useState("");
    const [configObject, setConfigObject] = useState(config || window[configName]);
    const [isLoading, setIsLoading] = useState(true);
    const [isFetching, setIsFetching] = useState(false);
    const [resultsTotal, setResultsTotal] = useState(0);
    const [filterObject, setFilterObject] = useState();
    const [jobadID, setJobadID] = useState(null);
    const [jobadsCampaignProperties, setJobadsCampaignProperties] = useState([]);
    const [pagination, setPagination] = useState({});
    const [sorter, setSorter] = useState({});
    const [relatedJobs, setRelatedJobs] = useState([]);
    const translationsRelatedJobs = translations[configObject.lang] ? translations[configObject.lang] : translations["de"];
    if (!Object.keys(config).length) {
        setErrorMessage({
            type: "error",
            code: "CONFIG_NOT_FOUND",
            description: "Config was not found.",
        });
    }
    useEffect(() => {
        const jobadID = getJobadID();
        window.dispatchEvent(new Event("TmsRelatedJobsLoaded")); // is loaded
        if (jobadID !== -1) {
            setIsFetching(true);
            setFilterObject((oldObj) => {
                return {
                    id: [jobadID],
                };
            });
            setJobadID(jobadID);
            return;
        }
        setIsFetching(false);
        setIsLoading(false);
    }, []);
    const getJobadID = () => {
        let url;
        let id;
        url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;
        if (window.location.hostname === "localhost") {
            url = window.location.href;
        }
        if (url.indexOf("/bewerbung") !== -1) {
            return -1;
        }
        if (url.split("/stellenangebote/")[1] !== undefined) {
            id = parseInt(url.split("/stellenangebote/")[1].split(/[--]+/)
                .pop());
        }
        return id;
    };
    /**
     * @param relatedJobsProperties myTalentionConfig.relatedJobs
     * @param campaignProperties All campaign properties from the jobad
     * @return Array of matching campaign properties
     */
    function findMatchingCampaignProperties(relatedJobsProperties, campaignProperties) {
        let matchingProperties = [];
        // Extract keys from relatedJobsProperties
        const relatedJobsKeys = relatedJobsProperties.map((key) => typeof key === 'string' ? key : key.name);
        // Filter matching campaign properties using relatedJobsKeys
        matchingProperties = campaignProperties.filter((campaignProperty) => {
            // Check every campaignProperty if they match the relatedJobsKey and return the whole property
            return relatedJobsKeys.find((relatedJobsPropertyKey) => {
                if (relatedJobsPropertyKey === campaignProperty.property) {
                    return true;
                }
            });
        });
        return matchingProperties;
    }
    useEffect(() => {
        if (filterObject?.id === undefined) {
            return;
        }
        if (Object.keys(filterObject).length !== 0) {
            if (filterObject.id.length > 0) {
                setRelatedProperties();
            }
            else {
                handleAPICall("handleRelatedJobs");
            }
        }
    }, [filterObject]);
    const setRelatedProperties = () => {
        RequestService.postRequest(`${configObject.clientURL}talention/api/3.2/job`, {
            filter: filterObject
        })
            .then((data) => {
            const { relatedJobs } = configObject;
            // Prüfen ob überhaupt Stellenanzeigen gefunden wurden
            if (data.resultsTotal === 0) {
                setIsFetching(false);
                setIsLoading(false);
                return true;
            }
            // Sicherstellen dass mindestens ein Ergebnis vorhanden ist
            const firstResult = data.results[0];
            if (!firstResult) {
                setIsFetching(false);
                setIsLoading(false);
                return false;
            }
            // Campaign Properties aus der API-Antwort extrahieren und um Location erweitern
            const campaignProperties = getCampaignProperties(data, firstResult);
            // Abbruch wenn keine verwertbaren Campaign Properties vorhanden sind
            if (campaignProperties.length === 0) {
                setIsFetching(false);
                setIsLoading(false);
                return false;
            }
            // Filter-Objekt für verwandte Jobs basierend auf Campaign Properties erstellen
            const campaignPropertiesFilter = createCampaignPropertiesFilter(relatedJobs, campaignProperties);
            // Alle State-Updates in einem Rutsch durchführen
            updateApplicationState(campaignProperties, campaignPropertiesFilter, firstResult, configObject);
            // Loading-States zurücksetzen
            setIsFetching(false);
            setIsLoading(false);
            // === Hilfsfunktionen ===
            /**
             * Extrahiert Campaign Properties aus der API-Antwort und fügt Location hinzu
             */
            function getCampaignProperties(data, firstResult) {
                // Bei Fehlern oder fehlenden Properties leeres Array zurückgeben
                if (data.error || !firstResult.campaignProperties) {
                    return [];
                }
                // Bestehende Campaign Properties mit Location-Property erweitern
                return [
                    ...firstResult.campaignProperties,
                    {
                        property: "location",
                        value: [firstResult.location]
                    }
                ];
            }
            /**
             * Erstellt Filter-Objekt basierend auf übereinstimmenden Campaign Properties
             */
            function createCampaignPropertiesFilter(relatedJobs, campaignProperties) {
                // Nur relevante Campaign Properties basierend auf relatedJobs-Konfiguration filtern
                const matchingCampaignProperties = findMatchingCampaignProperties(relatedJobs, campaignProperties);
                // Umwandlung von {property: 'abteilung', value: ['DevOps']} zu {'abteilung': ['DevOps']}
                return matchingCampaignProperties.reduce((filter, campaignProperty) => {
                    filter[campaignProperty.property] = campaignProperty.value;
                    return filter;
                }, {});
            }
            /**
             * Aktualisiert alle relevanten State-Variablen mit den neuen Daten
             */
            function updateApplicationState(campaignProperties, campaignPropertiesFilter, firstResult, configObject) {
                const { relatedPageSize, jobSorter, jobSorterOrder } = configObject;
                // Campaign Properties für weitere Verwendung speichern
                setJobadsCampaignProperties(campaignProperties);
                // Filter-Objekt für API-Anfrage zusammenstellen
                setFilterObject({
                    ...filterObject,
                    ...campaignPropertiesFilter,
                    id: [], // ID-Filter zurücksetzen um aktuelle Stellenanzeige auszuschließen
                    //@ts-ignore
                    category: [firstResult.category] || []
                });
                // Pagination-Einstellungen setzen (+1 für den Fall dass aktuelle Stelle gefiltert wird)
                setPagination({
                    max: relatedPageSize + 1 || 5
                });
                // Sortierung basierend auf Konfiguration oder Fallback-Werte
                setSorter({
                    sort: jobSorter || "createdDate",
                    order: jobSorterOrder || "desc"
                });
            }
        });
    };
    const handleAPICall = async (where) => {
        let locationObject = {};
        if (configObject.relatedJobsGeoRadius) {
            const index = jobadsCampaignProperties.findIndex((data) => {
                return data.property === "location";
            });
            if (typeof google !== "object") {
                locationObject = {};
                console.error("NO_GOOGLE_FOUND \n You tried to use a function that requires Google maps, but it was not found. Check your implementation or the key. Will ignore the Google maps functions like places autocomplete");
            }
            else {
                const geocoder = new google.maps.Geocoder();
                await geocoder.geocode({
                    address: decodeURIComponent(jobadsCampaignProperties[index]?.value[0])
                }, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        locationObject = {
                            lat: results[0].geometry.location.lat(),
                            lng: results[0].geometry.location.lng(),
                            radius: configObject.relatedJobsGeoRadius,
                            city: jobadsCampaignProperties[index].value[0]
                        };
                    }
                }).catch((error) => {
                    console.info(error);
                });
            }
        }
        RequestService.postRequest(`${configObject.clientURL}talention/api/3.2/job`, {
            filter: filterObject,
            location: locationObject,
            pagination,
            sorter
        })
            .then((data) => {
            const relatedJobsError = {
                title: "error",
                description: data.error,
                id: "error"
            };
            let maxResults = data.maxResults >= data.resultsTotal ? data.resultsTotal : data.maxResults;
            const relatedJobslist = data.results.filter((relatedJob) => {
                if (parseInt(relatedJob.id) === Number(jobadID)) {
                    maxResults--;
                }
                return Number(relatedJob.id) !== Number(jobadID);
            });
            if (maxResults > configObject.relatedPageSize) {
                maxResults = configObject.relatedPageSize;
            }
            relatedJobslist.length = configObject.relatedPageSize;
            setIsLoading(false);
            setIsFetching(false);
            setRelatedJobs(data.error ? [relatedJobsError] : relatedJobslist);
            setResultsTotal(maxResults);
            window.dispatchEvent(new Event("TmsRelatedJobsChanged"));
        });
    };
    /**
     * Does some magic
     *
     * @param {string} html A string that could contains html syntax.
     * @return {array} Returns the parameter string as html markup.
     */
    const createMarkup = (html) => {
        return { __html: html };
    };
    const { jobListProperties, disableJobListPropertyWrap, disableJobListTitleWrap, customRelatedJobsResultsText, } = configObject;
    let MaxResultsTag = "h1";
    if (hasErrored) {
        return React.createElement(TmsErrorHandler, { error: errorMessage });
    }
    if (isLoading || isFetching) {
        return (React.createElement("div", null,
            React.createElement(SkeletonTitle, null),
            React.createElement(SkeletonList, { filter: 3, count: configObject.relatedPageSize })));
    }
    if (resultsTotal === 0) {
        return;
    }
    if (customRelatedJobsResultsText) {
        if (customRelatedJobsResultsText.tag) {
            MaxResultsTag = customRelatedJobsResultsText.tag;
        }
        else if (customRelatedJobsResultsText.useH2) {
            MaxResultsTag = "h2";
        }
    }
    return (React.createElement("div", { className: "tms-relatedjobs-wrap" },
        React.createElement("section", { className: "joblist-maxresults" },
            React.createElement(MaxResultsTag, null,
                customRelatedJobsResultsText.prepend && (React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--prepend", dangerouslySetInnerHTML: createMarkup(customRelatedJobsResultsText.prepend) })),
                React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--hits" }, resultsTotal),
                React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--text" },
                    " ",
                    resultsTotal === 1 ? customRelatedJobsResultsText.single || translationsRelatedJobs.relatedJobFoundSingle : customRelatedJobsResultsText.multiple || translationsRelatedJobs.relatedJobFoundMultiple),
                customRelatedJobsResultsText.append && (React.createElement("span", { className: "joblist-maxresults-text joblist-maxresults-text--append", dangerouslySetInnerHTML: createMarkup(customRelatedJobsResultsText.append) })))),
        React.createElement(List, { attributes: configObject.link, jobSorter: configObject.jobSorter, showJoblistButton: configObject.showJoblistButton, jobListButtonText: configObject.jobListButtonText, parameter: configObject.parameterQuery, whatsapp: configObject.whatsapp, showJobListApplyButton: configObject.showJobListApplyButton, jobListProperties: jobListProperties, disableJobListTitleWrap: disableJobListTitleWrap, disableJobListPropertyWrap: disableJobListPropertyWrap, isFetching: isFetching, items: relatedJobs })));
};
export default TmsRelatedJobs;
